import myAxios from '../utils/request.js';
export default {
    async sendQAParam (params={}, cb) {
        let res = await myAxios.postJson('/lm/chat/qa', params);
        return res.data;
    },
    
    async closeConnect (params={}, cb) {
        let res = await myAxios.getJson('/lm/chat/closeConnect', params);
        return res.data;
    },

    // 重新问答 - 发送问答消息
    async reAnswer (params={}, cb) {
        let res = await myAxios.getJson('/lm/chat/reAnswer', params);
        return res.data;
    },

    // 主题问题推荐
    async getRecommendList (params={}, cb) {
        let res = await myAxios.getJson('/lm/chat/fileQuestions', params);
        return res.data;
    },

    // 结束当前话题（不联系上下文）
    async endQA (params={}, cb) {
        let res = await myAxios.getJson('/lm/chat/endQA', params);
        return res.data;
    },

    // 获取历史会话
    async pageQa (params={}, cb) {
        let res = await myAxios.postJson('/lm/qaLog/pageQa', params);
        return res.data;
    },

    
    // 删除回答内容
    async deleteALog (params={}, cb) {
        let res = await myAxios.getJson('/lm/qaLog/deleteALog', params);
        return res.data;
    },

    // 根据父id分页查询问答记录
    async pageAByParentId (params={}, cb) {
        let res = await myAxios.postJson('/lm/qaLog/pageAByParentId', params);
        return res.data;
    },

    // 对问答进行点赞点踩
    async evaluate (params={}, cb) {
        let res = await myAxios.getJson('/lm/qaLog/evaluate', params);
        return res.data;
    },
    

    // 查询对话记录
    async getRecentQa (params={}, cb) {
        let res = await myAxios.postJson('/lm/qaLog/getRecentQa', params);
        return res.data;
    },

    // 根据知识ID查询问答记录
    async getQaTitle (params={}, cb) {
        let res = await myAxios.postJson('/lm/qaLog/getQaTitle', params);
        return res.data;
    },
    // 删除问答记录
    async deleteQaLogByIds (params={}, cb) {
        let res = await myAxios.getJson('/lm/qaLog/deleteQaLogByIds', params);
        return res.data;
    },

    // // 修改问答标题名称
    async editQaTitle (params={}, cb) {
        let res = await myAxios.getJson('/lm/qaLog/editQaTitle', params);
        return res.data;
    },



}